<div class="flex-direction-column height-100 page">
  <div class="flex-direction-row justify-between align-center" [formGroup]="formOperador">

      <app-form-field style="margin-right: 1%" placeholder="Pesquisar" iconPrefix="search" iconColor="var(--primary)" backgroundColor="transparent" classe="pesquisar"
                      widthFormField="325px" heightFormField="35px" borderColor="var(--primary)" formControlName="nomeUsuario"></app-form-field>
  </div>

    <mat-table [dataSource]="operadoresDataSource">
      <ng-container matColumnDef="acao">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let elemento">
          <div class="flex-direction-row gap-5">
            <app-button-padrao iconSrc="icones/edit" iconSrcExtensao=".svg" width="30px" height="30px" backgroundColor="transparent"
                               widthIcon="22px" heightIcon="22px" (buttonClick)="abrirModal(false, elemento)"></app-button-padrao>
            <app-button-padrao iconSrc="icones/visualizar" iconSrcExtensao=".svg" width="30px" height="30px" backgroundColor="transparent"
                               widthIcon="20px" heightIcon="20px" (buttonClick)="abrirModal(true, elemento)"></app-button-padrao>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="foto">
        <mat-header-cell *matHeaderCellDef>Foto</mat-header-cell>
        <mat-cell *matCellDef="let elemento">
          @if (elemento.extensaoImg && elemento.uuid) {
            <img class="circulo" [src]="gerarUrl(elemento.uuid, elemento.extensaoImg, 'usuario-img')" style="width: 25px; height: 25px" alt="Foto do operador" />
          } @else {
            <img src="./assets/icones/no-img-default.png" style="width: 25px; height: 25px" alt="Foto do operador" />
          }
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="nome">
        <mat-header-cell *matHeaderCellDef>
          <p>Nome</p>
        </mat-header-cell>
        <mat-cell *matCellDef="let elemento" class="center-start" matTooltip="{{ elemento?.nome || '' }}">
          <p class="ellipse">{{ elemento?.nome || '-' }}</p>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="telefone">
        <mat-header-cell *matHeaderCellDef>
          <p>Telefone</p>
        </mat-header-cell>
        <mat-cell *matCellDef="let elemento" class="ellipse" matTooltip="{{ elemento?.telefone ? (elemento.telefone | celularMask) : '' }}">
          {{ elemento?.telefone ? (elemento.telefone | celularMask) : '-' }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="email">
        <mat-header-cell *matHeaderCellDef>E-mail</mat-header-cell>
        <mat-cell *matCellDef="let elemento">
          <span [matTooltip]="elemento.email" class="ellipse">
            {{ elemento.email }}
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="cpf">
        <mat-header-cell *matHeaderCellDef>
          <p>CPF</p>
        </mat-header-cell>
        <mat-cell *matCellDef="let elemento" class="ellipse" matTooltip="{{ elemento?.cpf ? (elemento?.cpf | cpfCnpjMask) : '' }}">
          {{ elemento?.cpf ? (elemento?.cpf | cpfCnpjMask) : '-' }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="setor">
        <mat-header-cell *matHeaderCellDef>
          <p>Setor</p>
        </mat-header-cell>
        <mat-cell *matCellDef="let elemento" class="ellipse" matTooltip="{{ elemento?.setorDTO ? elemento?.setorDTO.nome : '' }}">
          {{ elemento?.setorDTO ? elemento?.setorDTO.nome : '-' }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="usuarioCriacao">
        <mat-header-cell *matHeaderCellDef>
          <p>Usuário Criação</p>
        </mat-header-cell>
        <mat-cell *matCellDef="let elemento" class="center-start" matTooltip="{{ elemento?.nome || '' }}">
          <p class="ellipse">{{ elemento?.usuarioCriacao?.nome || '-' }}</p>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="dataCriacao">
        <mat-header-cell *matHeaderCellDef>Data Criação</mat-header-cell>
        <mat-cell *matCellDef="let elemento">
          {{ elemento?.dataCriacao ? (elemento.dataCriacao | date: 'dd/MM/yyyy HH:mm') : '-' }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="dataAlteracao">
        <mat-header-cell *matHeaderCellDef>Data Alteração</mat-header-cell>
        <mat-cell *matCellDef="let elemento">
          {{ elemento?.dataAlteracao ? (elemento.dataAlteracao | date: 'dd/MM/yyyy HH:mm') : '-' }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="canais">
        <mat-header-cell *matHeaderCellDef>Qtd Canais</mat-header-cell>
        <mat-cell *matCellDef="let elemento">{{ elemento.canais ? elemento.canais.length : 0 }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="ativo">
        <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
        <mat-cell *matCellDef="let elemento">
          {{ elemento.ativo ? 'Ativo' : 'Inativo' }}
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="12" style="text-align:center;">
          Nenhum resultado encontrado
        </td>
      </tr>

    </mat-table>

    @if (carregandoOperadores) {
      <app-tabela-skeleton [qntdLinhas]="8"></app-tabela-skeleton>
    }

  <img src="./assets/botao-add.svg" class="botao-add cursor-pointer" (click)="abrirModal(false)"
       (keydown.enter)="abrirModal(false)" tabindex="0" role="button" alt="Adicionar operador" />
</div>
